export default __webpack_public_path__ + "static/media/icon-direction droite.1a828bb1.svg";